import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="mt-16 border-t-2 border-black bg-[hsl(var(--nh-bg))]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8 flex flex-wrap gap-4 justify-between items-center text-sm text-black/70">
        <div data-testid="footer-copyright" className="font-medium">
          © {year} NurseLinkHub. All Rights Reserved.
        </div>
        <nav aria-label="Legal" className="flex flex-wrap items-center gap-x-5 gap-y-2">
          <Link to="/trust" data-testid="footer-trust" className="hover:text-black">Trust & stats</Link>
          <Link to="/terms" data-testid="footer-terms" className="hover:text-black">Terms of Use</Link>
          <Link to="/privacy" data-testid="footer-privacy" className="hover:text-black">Privacy Policy</Link>
          <Link to="/dmca" data-testid="footer-dmca" className="hover:text-black">DMCA</Link>
          <Link to="/agencies/new" data-testid="footer-agency-cta" className="hover:text-black">List your agency →</Link>
        </nav>
      </div>
    </footer>
  );
}
